import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { StackLayout, Text, Icon, useModalStore } from '@wemogy/reactbase';
import useAuthorizationTheme from '../../../theme/UseAuthorizationTheme';
var RoleListItem = function (_a) {
    var role = _a.role;
    var modalStore = useModalStore();
    var handleOpenRoleEditorModalPress = useCallback(function () {
        modalStore.openModal('manageRoleModal', { role: role, mode: 'edit' });
    }, [role]);
    var theme = useAuthorizationTheme().roleListItem;
    return (React.createElement(StackLayout, { marginBottom: true },
        React.createElement(StackLayout, { horizontal: true, spaceBetween: true, vCenter: true, padding: true, border: 0.25, borderColor: "grey200" },
            React.createElement(Text, { noTranslation: true }, role.name),
            React.createElement(Icon, { icon: theme.editIcon, variationKey: theme.editIconVariation, onPress: handleOpenRoleEditorModalPress }))));
};
export default observer(RoleListItem);
//# sourceMappingURL=RoleListItem.js.map